import { FC, useRef } from "react"
import { Upload } from "lucide-react"
import { ConnectorFormValues } from "../../../../../../types"

interface Props {
  onImport: (data: Partial<ConnectorFormValues>) => void
}

const ImportConnector: FC<Props> = ({ onImport }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = e => {
      try {
        const content = e.target?.result as string
        const jsonData = JSON.parse(content)

        // Validate and extract connector data
        const importedData: Partial<ConnectorFormValues> = {
          name: jsonData.name || "",
          type: jsonData.type || "webhook",
          brand_id: jsonData.brand_id || "",
          owner: jsonData.owner || "",
          direction: jsonData.direction || "outgoing",
          data_type: jsonData.data_type || "lead",
          webhook_url: jsonData.webhook_url || "",
          event: jsonData.event || "",
          field_mapping: jsonData.field_mapping || {},
          template: jsonData.template || "",
          config: jsonData.config || {},
          active:
            typeof jsonData.active === "string"
              ? parseInt(jsonData.active)
              : jsonData.active || 1
        }

        // Parse config if it's null/string
        if (!importedData.config || importedData.config === null) {
          importedData.config = {}
        }

        // Log imported data for debugging
        console.log("Importing connector data:", importedData)

        onImport(importedData)

        // Show success message
        alert(
          `Successfully imported connector configuration: ${
            importedData.name || "Unnamed"
          }`
        )

        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = ""
        }
      } catch (error) {
        console.error("Failed to parse JSON file:", error)
        alert("Invalid JSON file. Please check the file format and try again.")
      }
    }

    reader.readAsText(file)
  }

  const handleButtonClick = () => {
    fileInputRef.current?.click()
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onChange={handleFileSelect}
        className="hidden"
      />
      <button
        type="button"
        onClick={handleButtonClick}
        className="px-3 py-1 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 flex items-center"
      >
        <Upload size={14} className="mr-1" />
        Import JSON
      </button>
    </>
  )
}

export default ImportConnector
